import { IDataTableHeader } from '../../interfaces';

export interface IOCRData {
  assetId: string;
  contactId: string;
  contactName: string;
  currentValue: string;
  documentType: string;
  fieldName: string;
  isAutoFilled: boolean;
  isCoApplicant: boolean;
  ocrCreatedDate: string;
  ocrValue: string;
  stipTypeId: string;
  tableName: string;
}

export interface IOCRModalProps {
  ocrData: IOCRData[];
  loading: boolean;
  mutateOcrData: () => void;
  handleClose: () => void;
  ocrModalPosition: number;
}

export const OCR_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Field' },
  { label: 'Current Value' },
  { label: 'OCR Value' },
  { label: 'Status' },
];

export interface IOCRFormValues {
  currentValue: { [tableName: string]: boolean };
  ocrValue: { [tableName: string]: boolean };
}

export const CORRECT_OCR_FIELDS_ORDER = [
  { label: 'Driver\'s License Number', value: 'DriverLicenseNumber' },
  { label: 'First Name', value: 'FirstName' },
  { label: 'Middle Initial', value: 'MiddleInitial' },
  { label: 'Last Name', value: 'LastName' },
  { label: 'Date Of Birth', value: 'DateOfBirth' },
  { label: 'Driver\'s License State', value: 'DriverLicenseState' },
  { label: 'Driver\'s License Issues On Date', value: 'DriverLicenseIssuesOnDate' },
  { label: 'Driver\'s License Expiry', value: 'DriverLicenseExpireDate' },
  { label: 'Street', value: 'StreetLine1' },
  { label: 'City', value: 'City'},
  { label: 'State', value: 'State' },
  { label: 'Zip', value: 'Zip' },
];
